/**
 * Documentation Sections Configuration
 * Modular structure for UsageInfo documentation
 */

export const DOC_CATEGORIES = {
  GETTING_STARTED: "getting-started",
  CORE_FEATURES: "core-features",
  REPORTS: "reports-analysis",
  BILLING: "billing-invoices",
  ADVANCED: "advanced-features",
  HELP: "help-support",
};

export const DOCUMENTATION_SECTIONS = [
  {
    id: "24",
    title: "CIPC Automation — Complete Guide",
    category: DOC_CATEGORIES.ADVANCED,
    emoji: "📋",
    keywords: ["cipc", "guide", "annual returns", "beneficial ownership", "turnover", "years due", "fees", "secure approval", "confirmation", "filed", "billed", "automation", "follow-ups", "attachments", "weekly report", "audit history", "email activity", "troubleshooting"],
  },
  {
    id: "25",
    title: "Client Portal — Complete Guide",
    category: DOC_CATEGORIES.ADVANCED,
    emoji: "🤝",
    keywords: ["client portal", "client collaboration", "guide", "permissions", "invite", "overview", "practice inbox", "messages", "requests", "checklist", "recurrence", "reminders", "approvals", "documents", "invoice parsing", "journal", "reports", "sharing", "review notes", "notifications", "troubleshooting"],
  },
  {
    id: "1",
    title: "Signing up",
    category: DOC_CATEGORIES.GETTING_STARTED,
    emoji: "🔐",
    keywords: ["signup", "register", "account", "new user", "login"],
  },
  {
    id: "2",
    title: "Compliance Management",
    category: DOC_CATEGORIES.GETTING_STARTED,
    emoji: "✅",
    keywords: ["compliance", "vat", "cipc", "provisional tax", "tasks", "automation", "annual returns", "beneficial ownership", "secure approvals", "weekly summaries", "filing fees", "email activity"],
  },
  {
    id: "entities",
    title: "My Entities page",
    category: DOC_CATEGORIES.GETTING_STARTED,
    emoji: "🏢",
    keywords: ["entities", "companies", "add entities", "demo company"],
  },
  {
    id: "19",
    title: "Quickstart Guide",
    category: DOC_CATEGORIES.GETTING_STARTED,
    emoji: "🚀",
    keywords: ["quickstart", "first steps", "onboarding", "getting started"],
  },
  {
    id: "3",
    title: "Accounts & Transactions",
    category: DOC_CATEGORIES.CORE_FEATURES,
    emoji: "💼",
    keywords: ["accounts", "transactions", "auto allocate", "bank account", "allocation intelligence", "allocation history", "learned rules", "AI suggestions", "VAT changes"],
  },
  {
    id: "4",
    title: "Upload CSV Bank Statements",
    category: DOC_CATEGORIES.CORE_FEATURES,
    emoji: "📊",
    keywords: ["csv", "bank statement", "upload", "convert pdf", "extract"],
  },
  {
    id: "5",
    title: "Add Financial Years",
    category: DOC_CATEGORIES.CORE_FEATURES,
    emoji: "📅",
    keywords: ["add year", "financial year", "period", "out of year"],
  },
  {
    id: "6",
    title: "Batch Edit Transactions",
    category: DOC_CATEGORIES.CORE_FEATURES,
    emoji: "🧩",
    keywords: ["batch edit", "mass update", "reallocate", "transactions"],
  },
  {
    id: "7",
    title: "Transaction Pagination",
    category: DOC_CATEGORIES.CORE_FEATURES,
    emoji: "📄",
    keywords: ["pagination", "pages", "large datasets", "performance"],
  },
  {
    id: "10",
    title: "Edit Account Names",
    category: DOC_CATEGORIES.CORE_FEATURES,
    emoji: "✏️",
    keywords: ["rename", "account names", "custom names", "mapping"],
  },
  {
    id: "12",
    title: "Journal Entries",
    category: DOC_CATEGORIES.CORE_FEATURES,
    emoji: "🧾",
    keywords: ["journal", "journals", "manual entries", "adjustments", "monthly depreciation", "asset register", "recurring schedules", "residual value"],
  },
  {
    id: "14",
    title: "Payslips & Payroll",
    category: DOC_CATEGORIES.CORE_FEATURES,
    emoji: "💰",
    keywords: ["payroll", "payslips", "employees", "emp201", "uif", "payroll import", "historical payroll", "year-to-date", "YTD", "finalise", "reopen month", "recurring salaries"],
  },
  {
    id: "8",
    title: "Trial balance & Ledger",
    category: DOC_CATEGORIES.REPORTS,
    emoji: "⚖️",
    keywords: ["trial balance", "ledger", "date filter", "date range"],
  },
  {
    id: "11",
    title: "SOCE (Statement of Changes in Equity)",
    category: DOC_CATEGORIES.REPORTS,
    emoji: "📈",
    keywords: ["soce", "equity", "statement", "report"],
  },
  {
    id: "13",
    title: "VAT & Provisional Tax",
    category: DOC_CATEGORIES.REPORTS,
    emoji: "🧮",
    keywords: ["vat", "provisional tax", "tax", "returns"],
  },
  {
    id: "15",
    title: "Financial statement generation",
    category: DOC_CATEGORIES.REPORTS,
    emoji: "📚",
    keywords: ["afs", "financial statements", "soci", "sofp", "cash flow", "direct", "indirect", "monthly management pack", "dashboard", "PPE", "governance", "signatures", "approval", "notes", "report drafts"],
  },
  {
    id: "9",
    title: "Invoices & Billing",
    category: DOC_CATEGORIES.BILLING,
    emoji: "🧾",
    keywords: ["invoice", "invoices", "billing", "invoice payment", "customer statements", "supplier statements", "aging", "outstanding balances"],
  },
  {
    id: "17",
    title: "Billing & Payments",
    category: DOC_CATEGORIES.BILLING,
    emoji: "💳",
    keywords: ["payments", "subscription", "payfast", "trial"],
  },
  {
    id: "18",
    title: "Bank Feeds (Investec & FNB)",
    category: DOC_CATEGORIES.ADVANCED,
    emoji: "🏦",
    keywords: ["bank feeds", "investec", "fnb", "api", "sync"],
  },
  {
    id: "21",
    title: "Practice Directory Listing",
    category: DOC_CATEGORIES.ADVANCED,
    emoji: "📢",
    keywords: ["directory", "advertise", "practice", "listing"],
  },
  {
    id: "22",
    title: "Enterprise Task Management",
    category: DOC_CATEGORIES.ADVANCED,
    emoji: "🚀",
    keywords: ["tasks", "task management", "bulk operations", "analytics"],
  },
  {
    id: "23",
    title: "Collaboration & Engagement Workflows",
    category: DOC_CATEGORIES.ADVANCED,
    emoji: "🤝",
    keywords: [
      "client collaboration",
      "engagement letters",
      "engagement portal",
      "audit portal",
      "migration onboarding",
      "Pastel",
      "accounting import",
      "detailed general ledger",
      "opening balances",
      "reconciliation controls",
      "practice inbox",
      "structured requests",
      "client checklist",
      "recurring requests",
    ],
  },
  {
    id: "16",
    title: "User Icons & Settings",
    category: DOC_CATEGORIES.HELP,
    emoji: "⚙️",
    keywords: ["user profile", "settings", "2fa", "audit logs", "live chat"],
  },
  {
    id: "20",
    title: "Video Tutorials",
    category: DOC_CATEGORIES.HELP,
    emoji: "🎥",
    keywords: ["tutorials", "videos", "training", "learn"],
  },
];

export const CATEGORY_CONFIG = {
  [DOC_CATEGORIES.GETTING_STARTED]: {
    title: "🚀 Getting Started",
    color: "#059669",
    bgColor: "#f0fdf4",
    textColor: "#065f46",
    description: "Begin your FilingStack journey",
  },
  [DOC_CATEGORIES.CORE_FEATURES]: {
    title: "⚡ Core Features",
    color: "#0284c7",
    bgColor: "#f0f9ff",
    textColor: "#075985",
    description: "Essential tools and functions",
  },
  [DOC_CATEGORIES.REPORTS]: {
    title: "📊 Reports & Analysis",
    color: "#7c3aed",
    bgColor: "#f5f3ff",
    textColor: "#5b21b6",
    description: "Financial statements and insights with date filtering",
  },
  [DOC_CATEGORIES.BILLING]: {
    title: "💳 Billing & Invoices",
    color: "#ea580c",
    bgColor: "#fff7ed",
    textColor: "#9a3412",
    description: "Manage invoicing and payments",
  },
  [DOC_CATEGORIES.ADVANCED]: {
    title: "🔧 Advanced Features",
    color: "#dc2626",
    bgColor: "#fef2f2",
    textColor: "#991b1b",
    description: "Power user tools and automation",
  },
  [DOC_CATEGORIES.HELP]: {
    title: "❓ Help & Support",
    color: "#64748b",
    bgColor: "#f8fafc",
    textColor: "#334155",
    description: "Get assistance and resources",
  },
};

// Group sections by category
export const getSectionsByCategory = () => {
  const grouped = {};

  Object.values(DOC_CATEGORIES).forEach((category) => {
    grouped[category] = DOCUMENTATION_SECTIONS.filter(
      (section) => section.category === category,
    );
  });

  return grouped;
};

// Search functionality
export const searchSections = (query) => {
  if (!query) return DOCUMENTATION_SECTIONS;

  const lowerQuery = query.toLowerCase();

  return DOCUMENTATION_SECTIONS.filter((section) => {
    return (
      section.title.toLowerCase().includes(lowerQuery) ||
      section.keywords.some((keyword) =>
        keyword.toLowerCase().includes(lowerQuery),
      )
    );
  });
};
